<script setup lang="ts">
import type {LocationQueryValue} from '#vue-router'
import {cx} from 'class-variance-authority'

const filter = defineModel<string>()

const baseClass = 'px-4 h-8 transition-all border-b-2 border-transparent cursor-pointer'
const activeClass = 'border-b-2 !border-gray-900'
</script>

<template>
  <div class="flex justify-between">
    <div class="flex gap-3">
      <button type="button" :class="cx(baseClass, {[activeClass]: filter === 'recent'})" @click="filter = 'recent'">
        {{ $t('overflow.sort.recent') }}
      </button>
      <button type="button" :class="cx(baseClass, {[activeClass]: filter === 'liked'})" @click="filter = 'liked'">
        {{ $t('overflow.sort.liked') }}
      </button>
    </div>
  </div>
</template>
